import {Policy} from './client-model';

export class ClientFisico {
  groupFisico: GroupFisico;

  constructor() {
    this.groupFisico = new GroupFisico();
  }
}


export class GroupFisico {
  groupId: number;
  name: string;
  subgroups: Array<SubgroupFisico>;

  constructor() {
    this.groupId = 8;
    this.name = '';
    this.subgroups = new Array<SubgroupFisico>();
  }
}

export class SubgroupFisico {
  // tslint:disable-next-line:variable-name
  general_data: GeneralDataFisico;
  addressList: Array<AddressFisico>;
  documentationList: Array<DocumentationListFisico>;
  policies: Array<Policy>;

  constructor() {
    this.general_data = new GeneralDataFisico();
    this.addressList = new Array<AddressFisico>();
    this.documentationList = new Array<DocumentationListFisico>();
    this.policies = new Array<Policy>();
  }
}

export class GeneralDataFisico {
  clientId: number;
  rfc: string;
  name: string;
  firstName: string;
  lastName: string;
  clientType: number;
  type: string;
  groupId: number;
  status: boolean;
  comment: string;
  phone: string;
  email: string;

  constructor() {
    this.clientId = null;
    this.rfc = '';
    this.name = '';
    this.type = '';
    this.groupId = 0;
    this.status = true;
    this.comment = '';
  }
}

export class AddressFisico {
  addressId: number;
  clientId: number;
  country: string;
  zipCode: string;
  state: string;
  stateCode: string;
  municipalityCode: string;
  neighborhoodCode: string;
  street: string;
  streetCode: string;
  numExt: string;
  numInt: string;
  addressType: number;
  constructor(addressType: number) {
    this.addressId = null;
    this.clientId = null;
    this.country = 'MÉXICO';
    this.zipCode = null;
    this.stateCode = null;
    this.state = '';
    this.municipalityCode = null;
    this.neighborhoodCode = null;
    this.street = null;
    this.streetCode = null;
    this.stateCode = null;
    this.numExt = '';
    this.numInt = '';
    this.addressType = addressType;
  }
}

export class DocumentationListFisico {
  clientDocumentationId: number;
  name: string;
  path: string;
  base: string;
  receiptDate: string;
  dateCreated: string;
  dateUpdate: string;
  status: boolean;
  clientId: number;
  catTypeDocumentId: number;
  constructor() {
    this.clientDocumentationId = null;
    this.name = '';
    this.path = '';
    this.base = '';
    this.receiptDate = '';
    this.dateCreated = '';
    this.dateUpdate = '';
    this.status = null;
    this.clientId = 0;
    this.catTypeDocumentId = 0;
  }
}




